var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H2.5C1.83696 0.5 1.20107 0.763392 0.732233 1.23223C0.263392 1.70107 0 2.33696 0 3V23C0 23.663 0.263392 24.2989 0.732233 24.7678C1.20107 25.2366 1.83696 25.5 2.5 25.5H17.5C18.163 25.5 18.7989 25.2366 19.2678 24.7678C19.7366 24.2989 20 23.663 20 23V8L12.5 0.5ZM7.4975 16.46H6.11875V20.5525H4.9725V16.46H3.61625V15.5H7.4975V16.46ZM10.9037 20.5525L10.4475 19.6388C10.26 19.2863 10.14 19.0237 9.99875 18.7312H9.9825C9.87875 19.0225 9.75125 19.285 9.5925 19.6388L9.17375 20.5525H7.8675L9.33125 17.9962L7.92 15.5H9.2325L9.675 16.4225C9.82625 16.7287 9.9375 16.9763 10.0575 17.2613H10.0738C10.1938 16.9388 10.2913 16.7137 10.4188 16.4225L10.845 15.5H12.1487L10.725 17.9662L12.2225 20.5525H10.9037ZM16.3838 16.46H15.0038V20.5525H13.8575V16.46H12.5013V15.5H16.3825L16.3838 16.46ZM12.5 9.25H11.25V3L17.5 9.25H12.5Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.c0296715efd288594f4efc667dc4f533.svg";
export { ForwardRef as ReactComponent };